var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4 34H13.6C7.1893 34 3.9831 34 1.9924 32.0076C0.00169988 30.0152 0 26.8107 0 20.4V13.6C0 7.1893 -2.02656e-07 3.9831 1.9924 1.9924C3.9848 0.00169988 7.2063 0 13.651 0C14.6812 0 15.5057 -6.96629e-08 16.201 0.0288999C16.1783 0.1649 16.167 0.303167 16.167 0.4437L16.15 5.2615C16.15 7.1264 16.15 8.7754 16.3285 10.1031C16.5223 11.543 16.966 12.9829 18.1424 14.1593C19.3154 15.3323 20.757 15.7777 22.1969 15.9715C23.5246 16.15 25.1736 16.15 27.0385 16.15H33.9269C34 17.0578 34 18.173 34 19.6571V20.4C34 26.8107 34 30.0169 32.0076 32.0076C30.0152 33.9983 26.8107 34 20.4 34Z",
    fill: "#383838"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4983 9.54888L22.7664 3.49178C20.8505 1.76628 19.8934 0.902679 18.7153 0.452179L18.7 5.09998C18.7 9.10688 18.7 11.1112 19.9444 12.3556C21.1888 13.6 23.1931 13.6 27.2 13.6H33.286C32.6706 12.4032 31.5655 11.4104 29.4983 9.54888Z",
    fill: "#383838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiles);
export default __webpack_public_path__ + "static/media/files.33e0fc40fb5f49ff36393b423be1d02c.svg";
export { ForwardRef as ReactComponent };